<script lang="ts">
    import { _, locale } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { api, clientSettings } from '../../stores/api';
    import { isMapLoaded, routes } from '../../stores/store';
    import { z } from 'zod';
    import { openModal } from 'svelte-modals';
    import { app } from '../../stores/app';
    import type { RouteResponseType } from '../components/Connection/Routes/RoutesApi';
    import JobOneRow from '../components/Connection/RowDesign1/JobOneRow.svelte';
    import JobOneRowWrapper from '../components/Connection/RowDesign1/JobOneRowWrapper.svelte';
    import ModalCustom from './Modals/ModalCustom.svelte';
    import ModalError from './Modals/ModalError.svelte';
    import { LocationApi } from '../components/Location/LocationApi';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import { getJobColor } from '../utilities/getJobColor';
    import { Location } from '../components/Location/Location';
    import { LocationSearchItem } from '../components/Location/LocationSearchItem';

    export let map_key = ''; // get from API or from env
    export let mapPalette: string = 'simple';
    export let mapOptions = {
        container: 'TargeoContainer',
        z: 22,
        c: { y: 52.1565055, x: 21.0464574 },
        area: $app.settingsReadonly?.allowed_area !== 'pl' ? 'eu' : 'pl',
        modArguments: {
            Ribbon: { controls: ['MapMenu', 'FTS', 'FindRoute'] },
            Buildings3D: { disabled: false, on: true },
            POI: { disabled: true, submit: false, correct: false, visible: false },
            FTS: { disabled: false },
            FindRoute: {
                disabled: false,
                pro_prompt: true,
                tolls: true,
                routeOptions: addRouteOptions,
            },
            Traffic: { disabled: false, visible: false },
            Layers: {
                modes: ['map', 'satellite'],
                satsource: ['sentinel', 'geoportal', 'warszawa'],
            },
        },
        pointClusterDistance: $clientSettings.display.point_cluster_distance,
    };
    export let onMapLoad: (map: any) => void;
    export let uu: string = '';

    let isScriptCreated = false;
    let Mapa = Object;
    let routeParams: any = null;
    let routeDetails: RouteResponseType | null = null;
    let locationSearchIndex: any[] = [];
    // Język, z którym faktycznie został wczytany skrypt mapy. Targeo nie ma API do zmiany języka
    // w trakcie działania, więc jedyną reakcją na zmianę $locale jest przeładowanie skryptu i mapy.
    let loadedLn: string | null = null;

    // $locale bywa null, zanim svelte-i18n zdąży się zainicjować
    $: ln = $locale || 'pl';

    function addRouteOptions(route: any, opts: any[]) {
        if (route.mode == 'truck') {
            opts.splice(0, opts.length, {
                label: $_('Cost details'),
                icon: Targeo.Base.getSVGSrc(
                    '<path d="M14.73,19H7.4a2.33,2.33,0,0,1-2.33-2.33V9.33A2.33,2.33,0,0,1,7.4,7h4a1,1,0,0,1,0,2h-4a.33.33,0,0,0-.33.33v7.34A.33.33,0,0,0,7.4,17h7.33a.34.34,0,0,0,.34-.33v-4a1,1,0,0,1,2,0v4A2.34,2.34,0,0,1,14.73,19Z" fill="#77b024"/><path d="M19.07,6v4a1,1,0,0,1-2,0V8.41L11.44,14A1,1,0,0,1,10,14a1,1,0,0,1,0-1.41L15.65,7H14.07a1,1,0,0,1,0-2h4a1,1,0,0,1,.71.29A1,1,0,0,1,19.07,6Z" fill="#77b024"/>',
                    24,
                    24
                ),
                active: true,
                handler: function () {
                    getMapRouteData(route.id);
                },
            });
        }
    }

    function getMapRouteData(routeId: string) {
        $api.getData(
            'post',
            `/route/get_map_route_details`,
            {
                route_id: routeId,
                srv: parseInt(_TARGEO_GLOBALS.url.match('https://m(\\d)0.targeo.pl')[1]),
            },
            z.any(),
            z.any()
        )
            .then((attr: any) => {
                if (attr.toll_details.highways.per_category) {
                    let tax =
                        attr.toll_details.highways.price.netto > 0
                            ? Math.round((100 * attr.toll_details.highways.price.brutto) / attr.toll_details.highways.price.netto) / 100
                            : 1;
                    attr.toll_details.highways.per_category = attr.toll_details.highways.per_category.map((v: any) => {
                        return v / tax;
                    });
                    console.log('attr.toll_details.highways.per_category', attr.toll_details.highways.per_category, tax);
                } else {
                    attr.toll_details.highways.per_category = [
                        attr.toll_details.highways.price.netto,
                        attr.toll_details.highways.price.netto,
                        attr.toll_details.highways.price.netto,
                        attr.toll_details.highways.price.netto,
                    ];
                }
                if (attr.road_category_details) {
                    for (let k of ['distance', 'time']) {
                        attr.road_category_details[k] = {
                            highways: attr.road_category_details[k][0],
                            express: attr.road_category_details[k][1],
                            country: attr.road_category_details[k][2] + attr.road_category_details[k][3],
                        };
                    }
                } else {
                    attr.road_category_details = {
                        distance: {
                            highways:
                                (attr.toll_details['e-toll']['distance']['by_road_class'][0] || 0) +
                                (attr.toll_details.highways['distance']['by_road_class'][0] || 0),
                            express: attr.toll_details['e-toll']['distance']['by_road_class'][1] || 0,
                            country:
                                (attr.toll_details['e-toll']['distance']['by_road_class'][2] || 0) +
                                (attr.toll_details['e-toll']['distance']['by_road_class'][3] || 0),
                        },
                        time: {
                            highways: null,
                            express: null,
                            country: null,
                        },
                    };
                }
                routeDetails = {
                    connection: {
                        id: -1,
                    },
                    location_from: {
                        ext_id: 'A',
                        full_name: 'A',
                        geom: {
                            type: 'Point',
                            coordinates: [attr.points[0].c.x, attr.points[0].c.y],
                        },
                    },
                    location_to: {
                        ext_id: 'B',
                        full_name: 'B',
                        geom: {
                            type: 'Point',
                            coordinates: [attr.points[attr.points.length - 1].c.x, attr.points[attr.points.length - 1].c.y],
                        },
                    },
                    calculation: {
                        day: new Date().toISOString().slice(0, 10),
                    },
                    calculation_result: {
                        route_length: attr.params.length,
                        etoll_price: attr.toll_details['e-toll'].price.netto,
                        au_cat1: attr.toll_details.highways.per_category[0],
                        au_cat2: attr.toll_details.highways.per_category[1],
                        au_cat3: attr.toll_details.highways.per_category[2],
                        au_cat4: attr.toll_details.highways.per_category[3],
                        country_roads_length: attr.road_category_details.distance.country,
                        express_roads_length: attr.road_category_details.distance.express,
                        highway_roads_length: attr.road_category_details.distance.highways,
                        country_roads_time: attr.road_category_details.time.country,
                        express_roads_time: attr.road_category_details.time.express,
                        highway_roads_time: attr.road_category_details.time.highways,
                        total_time: attr.params.eta,
                    },
                    modified: false,
                    route_type: null,
                    outdated: false,
                };
                openModal(ModalCustom, {
                    component: JobOneRowWrapper,
                    componentProps: {
                        route: routeDetails,
                        index: -2,
                        expandedIndex: -2,
                        switchable: false,
                        showNote: false,
                        simpleView: true,
                    },
                    width: 600,
                    height: null,
                });
            })
            .catch((err: any) => {
                console.error('getMapRouteData', err);
            });
    }

    function createMapScript() {
        /*
         script src="https://mapa.targeo.pl/Targeo.html?vn=3_0&v=full&k=...........ZDBkOQ==&m=0&e=TargeoContainer&f=LoadMods&xhr=1"
         */
        if (!isScriptCreated) {
            console.info('Create script tag for map');
            let map_script = document.createElement('script');
            // map_script.setAttribute("src", `https://mapa.targeo.pl/Targeo.html?vn=3_0&rv=new&k=${this.map_key}&m=1&f=pageInitialize&e=TargeoMapContainer&ln=pl`);
            // map_script.setAttribute("src", `https://mapa.targeo.pl/Targeo.html?vn=3_0&rv=pro&k=${map_key}&m=1&f=pageInitialize&e=TargeoMapContainer&ln=pl`);
            // map_script.setAttribute("src", `https://mapa.targeo.pl/Targeo.html?vn=3_0&rv=full&k=${map_key}&m=0&f=LoadMods&e=TargeoContainer&ln=pl&xhr=1`);
            map_script.setAttribute(
                'src',
                `https://mapa.targeo.pl/Targeo.html?vn=3_0&k=${map_key}&m=0&f=unusedFunction&e=TargeoContainer&ln=${ln}&xhr=1` +
                    (uu ? '&uu=' + uu : '')
            );
            map_script.setAttribute('type', 'text/javascript');
            // marker pozwalający odnaleźć tag przy przeładowaniu mapy (zmiana języka)
            map_script.setAttribute('data-id', 'TargeoMapScript');
            document.body.appendChild(map_script);
            console.log('TargeoMap, loading language:', ln);
            isScriptCreated = true;
            loadedLn = ln;
        }
        return new Promise((resolve, reject) => {
            if (typeof Targeo !== 'undefined') {
                resolve(null);
            } else {
                const intervalMap = setInterval(() => {
                    console.log('checking for targeo element');
                    // @ts-ignore Targeo is global
                    if (typeof Targeo !== 'undefined') {
                        console.log('Targeo element found');
                        clearInterval(intervalMap);
                        resolve(null);
                    }
                }, 100);
            }
        });
    }

    function getRouteTypes() {
        return $api.getData('post', `/route_type/query`, { active: true }, z.any(), z.any());
    }

    function normalizeStringForSearch(string: string) {
        try {
            string = string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        } catch (e) {}
        return string.toLowerCase();
    }

    function searchLocations(searchString: string) {
        console.log('searchLocations', searchString);
        let results = [];
        let tokens = normalizeStringForSearch(searchString).split(/\s+/).filter(function(v){ return v.length; });
        let jj = tokens.length;
        if (jj > 0) {
            for (let i = 0, ii = locationSearchIndex.length; i < ii; i++) {
                let item = locationSearchIndex[i];
                let notmatched = jj;
                for (let j = 0; j < jj; j++) {
                    if ((tokens[j].length >= 3 && item.tokens.indexOf(tokens[j]) >= 0) || (tokens[j].length < 3 && item.tokens.match(new RegExp("(^|\\s)"+tokens[j]+"(\\s|$)")))) {
                        notmatched--;
                    } else {
                        break;
                    }
                }
                if (!notmatched) {
                    results.push({
                        view: item.object.full_name,
                        src: {
                            type: LocationSearchItem,
                            id: item.object.ext_id,
                            name: item.object.full_name,
                            address: item.object.address_attributes,
                            xy: {x: item.object.geom.coordinates[0], y: item.object.geom.coordinates[1]},
                            color: getJobColor(new Location().set(item.object))
                        }
                    });
                }
            }
        }
        return results;
    }

    function loadMap() {
        return new Promise((resolve, reject) => {
            if (typeof Targeo !== 'undefined' && Targeo.Base?.Map) {
                resolve(null);
            } else {
                mapOptions = {
                    ...mapOptions,
                    container: 'TargeoContainer',
                };
                if (mapPalette) {
                    mapOptions.palette = mapPalette;
                }
                // @ts-ignore
                Mapa = new Targeo.Map(mapOptions);
                // @ts-ignore
                Targeo.Base.addCSSs({
                    //'/#map #TargeoContainer .targeo-spread-container': 'background: radial-gradient(circle, #fffffffa 0%, #ffffff33 45%, #ffffff00 70%);',
                    //'/#map #TargeoContainer .targeo-spread-label': 'background-color: rgba(52, 52, 52, 0.9);',
                    //'/#map #TargeoContainer .targeo-spread-spoke': 'stroke: #999',
                    '.targeo-spread-label span': 'display: inline-block; margin: 0 3px; font-weight: bold',
                    '.targeo-spread-label span:first-child': 'margin-left: 0;',
                    '.targeo-spread-label span:last-child': 'margin-right: 0;',
                });
                Mapa.listen('onInit', function () {
                    //set default route parameters
                    if (routeParams !== null) {
                        setTimeout(function () {
                            Mapa.modules.FindRoute.setRouteParameters(routeParams);
                        }, 0);
                    }
                    console.log('Mapa, onInit (1)');
                    LocationApi.filter($api, new ApiFilterBuilder(-1)).then(response => {
                        console.log('Mapa, onInit (2)', response);
                        if (response.length > 0) {
                            var i, ii, j, obj, objtokens;
                            for (i = 0, ii = response.length; i < ii; i++) {
                                obj = response[i];
                                objtokens = normalizeStringForSearch([obj.ext_id, obj.full_name].join(' '));
                                locationSearchIndex.push({tokens: objtokens, object: response[i]});
                            }
                            Targeo.FTSForm.registerSearcher('etoll-locations', searchLocations, {limit: 10});
                        }
                    });
                    resolve(null);
                });
                // @ts-ignore
                Mapa.initialize();
                Mapa.modules.FindRoute.listen('onRouteFound', function (evt) {
                    let settings = $app.settingsReadonly;
                    let limit = settings.max_transactions_per_month;
                    let allowExceeding = settings?.allow_limit_exceeding;
                    let current = $routes.currentTransactionCount;
                    if (allowExceeding || !limit || !current || limit > current.count) {
                        $api.getData(
                            'post',
                            '/route/log_transaction',
                            { type: 'map', points: Targeo.Base.Map.modules.FindRoute.getRoutePoints() },
                            z.any(),
                            z.any()
                        );
                    } else {
                        openModal(ModalError, {
                            header: $_('Error'),
                            message: $_('transaction_limit_exceeded', {values: {limit: limit}}),
                        });
                        Mapa.modules.FindRoute.setRoute([], routeParams);
                    }
                });
                // @ts-ignore
                //if (mapPalette) Mapa.setPalette(mapPalette);
            }
        });
    }

    /**
     * Usuwa tag skryptu mapy i zeruje WSZYSTKIE globale Targeo. Bez wyczyszczenia globali ponownie
     * wczytany skrypt nie zainicjuje mapy - Targeo uznaje, że jest już załadowane.
     */
    function removeScript() {
        let script = document.querySelector('script[data-id="TargeoMapScript"]');
        if (script) {
            Mapa = Object;
            if (typeof Targeo !== 'undefined') {
                // @ts-ignore Targeo global
                Targeo = undefined;
            }
            // @ts-ignore Targeo global
            if (typeof _TARGEO_GLOBALS !== 'undefined') {
                // @ts-ignore Targeo global
                _TARGEO_GLOBALS = undefined;
            }
            // @ts-ignore Targeo global
            if (typeof _TARGEO_BROWSER !== 'undefined') {
                // @ts-ignore Targeo global
                _TARGEO_BROWSER = undefined;
            }
            // @ts-ignore Targeo global
            if (typeof ___targeo___analysed___ !== 'undefined') {
                // @ts-ignore Targeo global
                ___targeo___analysed___ = undefined;
            }
            // @ts-ignore Targeo global
            if (typeof ___targeo___Maps___ !== 'undefined') {
                // @ts-ignore Targeo global
                ___targeo___Maps___ = undefined;
            }
            console.log('TargeoMap, remove script');
            script.remove();
            isScriptCreated = false;
        }
    }

    async function initMap() {
        // przy przeładowaniu mapy (zmiana języka) konsumenci czekający w onMapReady() muszą zobaczyć
        // false, a indeks lokalizacji dla FTS trzeba wyzerować - inaczej wyniki wyszukiwania się dublują
        $isMapLoaded = false;
        locationSearchIndex = [];

        let response: any[] = await Promise.all([createMapScript(), getRouteTypes()]);
        if (response[1].length) {
            let routeTypeAttributes = response[1][0].attributes;
            routeParams = { mode: 'truck', truck: null };
            if (routeTypeAttributes.vehicle) {
                routeParams.truck = {
                    weight: routeTypeAttributes.vehicle.weight,
                    load: routeTypeAttributes.vehicle.load,
                    width: routeTypeAttributes.vehicle.width,
                    height: routeTypeAttributes.vehicle.height,
                    len: routeTypeAttributes.vehicle.length,
                    real: false,
                    vehicle_cat_for_toll: routeTypeAttributes.vehicle.category.filter((c: number) => c > 1)[0],
                    euro_norm_for_viatoll: routeTypeAttributes.vehicle.euro_norm[0],
                    etoll_weight_class: routeTypeAttributes.vehicle.weight >= 12 ? 1 : 2,
                };
            } else {
                routeParams.mode = 'car';
            }
            if (routeTypeAttributes.start_time) {
                let cdate: Date = new Date();
                cdate.setHours(parseInt(routeTypeAttributes.start_time.split(':')[0]));
                cdate.setMinutes(parseInt(routeTypeAttributes.start_time.split(':')[1]));
                routeParams.time = cdate.getTime();
            }
            console.log('routeParams', routeParams);
        }

        await loadMap();

        if (typeof onMapLoad === 'function') {
            console.log('callbacks.onMapLoad');
            onMapLoad(Mapa);
        }
    }

    onMount(() => {
        removeScript();
        initMap().catch(e => console.error('TargeoMap, initMap failed', e));

        return () => {
            console.log('TargeoMap, cleanup');
            removeScript();
        };
    });

    // Targeo nie umie zmienić języka w działającej mapie - przy zmianie $locale burzymy skrypt
    // i globale, po czym budujemy mapę od nowa z nowym parametrem ln.
    $: {
        if (loadedLn !== null && loadedLn !== ln && isScriptCreated) {
            loadedLn = null;
            console.log('TargeoMap, language selected:', ln);
            removeScript();
            initMap().catch(e => console.error('TargeoMap, initMap failed', e));
        }
    }
</script>

<div class="map" id="map">
    <a href="https://mapa.targeo.pl/" id="TargeoContainer" title="Mapa Polski" style="height: 100%;"></a>
    <!-- If the map is not loaded, please set your key map in Settings -->
</div>

<style>
    .map {
        height: 100%;
        width: 100%;
        /*z-index:300;*/
    }
</style>
